import { createContext as e } from "react";
//#region src/context/AdminAuthContext.ts
var t = e(null);
//#endregion
export { t as AdminAuthContext };
